import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DownloadBillFormComponent from './DownloadBillFormComponent';
import HeadComponent from '../../../HeadComponent';
import { withTemplate } from '../../../template/withTemplate';
import { PrimaryTemplate } from '../../../template/PrimaryTemplate';
import queryString from 'query-string';

const DownloadEbonBillPage = ({ i18n }) => {
    const locationParsed = queryString.parse(window.location.search);
    return (
        <main className="conteneur conteneur-mobile" id="p-contactrequest">
            <HeadComponent title={i18n.BILL.TITLE} description={i18n.DESCRIPTION} />
            <h1>{i18n.BILL.TITLE}</h1>
            <DownloadBillFormComponent
                orderId={locationParsed.orderId}
                email={locationParsed.email}
                hmac={locationParsed.hmac}
            />
        </main>
    );
};

DownloadEbonBillPage.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default withTemplate(connect(mapStateToProps)(DownloadEbonBillPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/download/DownloadEbonBillPage.js